const common = {
  "site.name": "豆花视频",
  "site.slogan": "发现精彩，畅享高清",
  "site.description": "正版高清视频内容平台",
  "nav.home": "首页",
  "nav.category": "分类浏览",
  "nav.about": "关于我们",
  "nav.search": "搜索内容...",
  "home.hero.title": "发现精彩世界",
  "home.hero.subtitle": "海量高清影视、短视频、生活娱乐内容，随时随地畅享豆花视频带来的精彩视觉体验",
  "home.hero.cta": "立即免费观看",
  "home.hero.secondary": "了解更多",
  "home.categories.title": "热门分类",
  "home.categories.subtitle": "探索你感兴趣的精彩内容",
  "home.hot.title": "热门推荐",
  "home.hot.subtitle": "大家都在看的精彩内容",
  "home.hot.viewMore": "查看更多",
  "home.faq.title": "常见问题",
  "home.faq.subtitle": "快速了解豆花视频",
  "footer.rights": "版权所有",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "footer.contact": "联系我们",
  "category.all": "全部",
  "category.movie": "电影",
  "category.tv": "电视剧",
  "category.variety": "综艺",
  "category.documentary": "纪录片",
  "category.anime": "动漫",
  "category.short": "短视频",
  "category.music": "音乐",
  "category.lifestyle": "生活",
  "breadcrumb.home": "首页",
  "article.related": "相关推荐",
  "article.backToList": "返回列表",
  "about.title": "关于豆花视频",
  "about.brand.title": "品牌介绍",
  "about.reputation.title": "用户口碑",
  "about.contact.title": "联系我们",
  "about.contact.address": "公司地址",
  "about.contact.phone": "客服电话",
  "about.contact.email": "电子邮箱",
  "about.contact.wechat": "官方微信",
  "notFound.title": "页面未找到",
  "notFound.description": "您访问的页面不存在或已被移除",
  "notFound.backHome": "返回首页",
};

export default common;